// App.tsx
import "./App.css";
import RoutesWrapper from "./routes/route-wrapper";
import { Toaster } from "sonner";
import ScrollToTop from "./routes/scroll-top";
import { WebSocketProvider } from "./components/crm/socket-context";
import { GlobalNotificationHandler } from "./components/global-notificationbell";
import { ThemeProvider } from "./context/theme-context";
import ErrorBoundary from "./components/error-boundary";
import SupportWidget from "./views/crm-pages/support-bot/support-widget";

// Hoisted to stable, module-level references on purpose — WebSocketProvider
// (socket-context.tsx) threads these through a useCallback/useEffect chain
// that tears down and rebuilds the entire WebSocket connection, its 5s
// reconnect-poll interval, and its focus/storage/visibilitychange listeners
// whenever either reference changes. Passing new inline arrow functions here
// on every App render meant that chain re-ran on every App render — mostly
// invisible in production (App has no state/props of its own to re-render
// from), but very real under the dev server, where webpack Fast Refresh
// re-executes App on file changes with no clean refresh boundary: every such
// reload was silently closing and reopening the live socket.
const handleWsConnected = () => {};
const handleWsDisconnected = () => {};

function App() {
  return (
    <ThemeProvider>
      <WebSocketProvider
        onConnected={handleWsConnected}
        onDisconnected={handleWsDisconnected}
      >
        <GlobalNotificationHandler />
        <ScrollToTop />
        <SupportWidget />
        <ErrorBoundary>
          <RoutesWrapper />
        </ErrorBoundary>
        <Toaster position="top-right" richColors expand />
      </WebSocketProvider>
    </ThemeProvider>
  );
}

export default App;